import ScopesPlugin from './scopes/ScopesPlugin';

export default {
    ScopesPlugin,
};
